module.exports = __webpack_public_path__ + "img/Anhänger_DLE.668cb088.svg";